export { default as RestaurantCover } from './RestaurantCover'
export { default as RestaurantCoverSkeleton } from './Skeleton'
